export default __webpack_public_path__ + "static/media/academia_de_lenguas_white.a837fe39.png";